var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenConsultHeartButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2501 2.5C16.7814 2.5 18.8334 4.58333 18.8334 7.5C18.8334 13.3333 12.5834 16.6667 10.5001 17.9167C8.41675 16.6667 2.16675 13.3333 2.16675 7.5C2.16675 4.58333 4.25008 2.5 6.75008 2.5C8.30006 2.5 9.66675 3.33333 10.5001 4.16667C11.3334 3.33333 12.7001 2.5 14.2501 2.5Z",
    fill: "#FF8CBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenConsultHeartButton);
export default __webpack_public_path__ + "static/media/open-consult-heart-button.8afe19ca1a3b67c079e53d48ca4287ff.svg";
export { ForwardRef as ReactComponent };